import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../components/Navbar';
import { createAllPhaseMenuGroups } from '../../../utils/createAllPhaseMenuGroups';
import TopBannerGuidance from '../../../components/TopBannerGuidance';
import {
  Book as BookIcon,
  Person as PersonIcon,
  School as ClassIcon,
  Settings as PrepSettingsIcon,
  Home as PrepHomeIcon,
  Send as SendIcon
} from '@mui/icons-material';
import { Box } from '@mui/material';

export default function Settings() {
  const navigate = useNavigate();
  const [showOwlGuidance, setShowOwlGuidance] = useState(true);

  // A-3: 使用分層架構選單（設定頁面不需要在選單中顯示）
  const allPhaseMenuGroups = createAllPhaseMenuGroups('preparation', 'settings', navigate);

  return (
    <div className="teacher-layout settings-container">
      <div className="main-content-v2">
        <Navbar 
          allPhaseMenuGroups={allPhaseMenuGroups}
          currentPhase="preparation"
          onPhaseChange={(phase) => {
            if (phase === 'preparation') {
              navigate('/teacher/preparation');
            } else if (phase === 'implementation') {
              navigate('/teacher/implementation');
            } else if (phase === 'diagnosis') {
              navigate('/teacher/diagnosis');
            }
          }}
        />
        
        <div className="class-header-row">
          <h1 className="main-title">系統設定</h1>
        </div>

        {/* 空白內容區域 */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          minHeight: '400px',
          color: '#999',
          fontSize: '1.2rem'
        }}>
          設定頁面內容待開發...
        </Box>

        {/* 頂部橫幅提醒 */}
        <TopBannerGuidance
          show={showOwlGuidance}
          onClose={() => setShowOwlGuidance(false)}
          severity="info"
          message="設定頁面目前還在開發中。如果需要調整系統設定，請聯繫系統管理員。"
        />
      </div>
    </div>
  );
}